export default "__VITE_ASSET__CiRXCovx__"